/*
 * @Author: czj
 * @Date: 2026-07-30 09:44:50
 * @Description: 
 * @FilePath: \kp-rag-system\src\router\constantRoutes.js
 */
/**
 * 常量路由（无需权限，始终可访问）
 * @file src/router/constantRoutes.js
 * @description 登录页 + 根布局容器（动态路由作为其子路由注入）
 */
const constantRoutes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: { title: '登录', noCache: true },
  },
  // 根路径 — 使用 Layout 作为容器，后续动态路由作为子路由注入
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/index.vue'),
    redirect: '/home',
    meta: { title: '首页' },
    children: [
      // {
      //   path: 'home',
      //   name: 'Home',
      //   component: () => import('@/views/Home/index.vue'),
      //   meta: { title: '首页' },
      // },
    ],
  },
  // 404 兜底路由（当动态路由未命中时显示）
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('@/views/error-page/404.vue'),
    meta: { title: '404', noCache: true },
    hidden: true,
  },
]

export default constantRoutes
